export default __webpack_public_path__ + "static/media/uptime.0fc479a2.svg";